export default __webpack_public_path__ + "static/media/others.d38928bb.jpg";